var map = {
	"./assets/image/sgtest/result/kurisu/tip_1.png": "b5b0",
	"./assets/image/sgtest/result/mayuri/tip_1.png": "c3c1",
	"./assets/image/sgtest/result/rintarou/tip_1.png": "0266",
	"./assets/image/sgtest/result/suzuha/tip_1.png": "7f27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10f3";